
(function() {
    function onTidioChatApiReady() {
        window.tidioChatApi.hide();
        window.tidioChatApi.on("close", function() {
            window.tidioChatApi.hide();
        });
    }

    if (window.tidioChatApi) {
        window.tidioChatApi.on("ready", onTidioChatApiReady);
    } else {
        document.addEventListener("tidioChat-ready", onTidioChatApiReady);
    }

    // Wait for the DOM to be fully loaded
    document.addEventListener("DOMContentLoaded", function() {
        var chatButton = document.querySelector(".chat-button");
        if (chatButton) {
            chatButton.addEventListener("click", function(e) {
                e.preventDefault(); // Prevent default link behavior
                window.tidioChatApi.show();
                window.tidioChatApi.open();
            });
        }
    });
})();

